import React, { useState, useEffect } from 'react';

// Styling
import './styles/GlobalStyles.css';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ExpertiseStrip from './components/ExpertiseStrip';
import DomainExpertise from './components/DomainExpertise';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Process from './components/Process';
import Capabilities from './components/Capabilities';
import CTA from './components/CTA';
import Footer from './components/Footer';
import ProposalModal from './components/ProposalModal';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNavSolid, setIsNavSolid] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [cursorScale, setCursorScale] = useState(1);
  const [ringPosition, setRingPosition] = useState({ x: 0, y: 0 });
  const [ringColor, setRingColor] = useState('rgba(0,200,150,0.35)');

  useEffect(() => {
    // Scroll handling
    const handleScroll = () => {
      setIsNavSolid(window.scrollY > 50);
    };

    // Intersection Observer for Reveal Animations
    const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -40px 0px' };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
        }
      });
    }, observerOptions);

    const revealElements = document.querySelectorAll('.rev');
    revealElements.forEach((el) => observer.observe(el));

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      revealElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  useEffect(() => {
    // Cursor handling
    let animationFrameId;
    let currentX = mousePosition.x;
    let currentY = mousePosition.y;

    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    const animateRing = () => {
      currentX += (mousePosition.x - currentX) * 0.1;
      currentY += (mousePosition.y - currentY) * 0.1;
      setRingPosition({ x: currentX, y: currentY });
      animationFrameId = requestAnimationFrame(animateRing);
    };

    window.addEventListener('mousemove', handleMouseMove);
    animateRing();

    // Attach hover effects to buttons/links
    const handleMouseEnter = () => {
      setCursorScale(2.5);
      setRingColor('rgba(0,200,150,0.6)');
    };
    const handleMouseLeave = () => {
      setCursorScale(1);
      setRingColor('rgba(0,200,150,0.35)');
    };

    const interactables = document.querySelectorAll('a, button');
    interactables.forEach(el => {
      el.addEventListener('mouseenter', handleMouseEnter);
      el.addEventListener('mouseleave', handleMouseLeave);
    });

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(animationFrameId);
      interactables.forEach(el => {
        el.removeEventListener('mouseenter', handleMouseEnter);
        el.removeEventListener('mouseleave', handleMouseLeave);
      });
    };
  }, [mousePosition]);

  const toggleModal = (e) => {
    if (e) e.preventDefault();
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className={`App ${isModalOpen ? 'proposal-modal-open' : ''}`}>
      {/* Cursors */}
      <div 
        className="c-dot" 
        style={{ 
          left: `${mousePosition.x}px`, 
          top: `${mousePosition.y}px`,
          transform: `translate(-50%, -50%) scale(${cursorScale})`
        }} 
      />
      <div 
        className="c-ring" 
        style={{ 
          left: `${ringPosition.x}px`, 
          top: `${ringPosition.y}px`,
          borderColor: ringColor
        }} 
      />

      <Navbar isSolid={isNavSolid} onContactClick={toggleModal} />

      <Hero onContactClick={toggleModal} />
      
      <ExpertiseStrip />
      
      <DomainExpertise />
      
      <Services />
      
      <WhyUs />

      <Process />

      <Capabilities />

      <CTA />

      <Footer />

      <ProposalModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />

      {/* Hidden Netlify static form for detection */}
      <form name="project-proposal" method="POST" data-netlify="true" netlify-honeypot="bot-field" className="netlify-static-form">
        <input type="hidden" name="form-name" value="project-proposal" />
        <input type="text" name="name" />
        <input type="email" name="email" />
        <input type="text" name="company" />
        <input type="tel" name="phone" />
        <input type="text" name="project_type" />
        <input type="text" name="budget" />
        <textarea name="summary"></textarea>
        <textarea name="timeline"></textarea>
        <input name="bot-field" />
      </form>
    </div>
  );
}

export default App;